<template>
  <div class="homeMain" @click="select_selected = false">
    <link
      href="https://use.fontawesome.com/releases/v5.0.6/css/all.css"
      rel="stylesheet"
    />
    <link
      href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
      rel="stylesheet"
    />

    <v-card class="weekSelector" flat>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="2" align="right">
          <v-btn small fab v-on:click="calendarPrev()">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
          <p class="h5 pt-2">{{ calendarDateStart }} - {{ calendarDateEnd }}</p>
        </v-col>
        <v-col cols="2" align="left">
          <v-btn small fab v-on:click="calendarNext()">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="1">
          <!--<v-btn large rounded v-on:click="loadEvents()">
            <v-icon>refresh</v-icon>
          </v-btn>-->
        </v-col>
      </v-row>
    </v-card>

    <v-card flat class="calendarSection">
      <v-row no-gutters>
        <v-col
          cols="12"
          sm="12"
          lg="6"
          class="pa-3"
          v-for="(loc, idx) in locations"
          :key="idx"
        >
          <v-card class="pa-3" color="white">
            <v-row>
              <v-col cols="auto">
                <p class="h4 text-left">{{ loc }}</p>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" align="right">
                <v-btn
                  class="white--text"
                  color="cyan"
                  v-if="actual_location == idx && select_selected"
                  v-on:click="dialog_book = true"
                  >Reservieren</v-btn
                >
                <v-icon
                  class="mr-5"
                  v-if="actual_location == idx && event_selected"
                  v-on:click="generateICS"
                  >mdi-calendar</v-icon
                >
                <v-btn
                  class="white--text"
                  color="red"
                  v-if="actual_location == idx && event_selected"
                  v-on:click="dialog_event = true"
                  >Stornieren</v-btn
                >
              </v-col>
            </v-row>

            <FullCalendar
              :ref="fullCalendarName[idx]"
              :defaultView="calendarView"
              :plugins="calendarPlugins"
              :events="
                calendarEvents.filter((ev) => {
                  return ev.location == idx;
                })
              "
              :header="false"
              :weekends="true"
              :selectable="true"
              :nowIndicator="true"
              :slotDuration="{ hours: 1 }"
              :slotLabelFormat="{
                hour: '2-digit',
                minute: '2-digit',
              }"
              :slotLabelInterval="{ hours: 1 }"
              locale="deLocale"
              :unselectAuto="true"
              :selectOverlap="checkOverlap"
              :selectAllow="maxSelect"
              :minTime="minTime"
              :maxTime="maxTime"
              :allDaySlot="false"
              :columnHeaderFormat="{ weekday: 'short' }"
              :firstDay="1"
              height="auto"
              @eventClick="eventClick($event, idx)"
              @dateClick="dateClick($event, idx)"
              @select="dateSelect($event, idx)"
              draggable="false"
              themeSystem="default"
              :displayEventTime="false"
              :longPressDelay="500"
              :selectLongPressDelay="500"
              :eventLongPressDelay="500"
              :eventRender="test"
            />
            <!---->
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialog_event" max-width="400px">
      <v-card shaped>
        <v-card-title>
          <span class="headline"
            >Stornieren {{ locations[actual_location] }}</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center h5">
                {{ $moment(event.start).format("dddd DD MMMM YYYY") }}
                <br />
                <br />
                {{ $moment(event.start).format("HH:mm") }} -
                {{ $moment(event.end).format("HH:mm") }} ({{
                  $moment(event.end - event.start - 1).format("h")
                }}
                h)
                <br />
                <br />stornieren?
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red darken-1"
            text
            @click="
              dialog_event = false;
              close_dialog();
            "
            >Abbrechen</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              dialog_event = false;
              cancel();
            "
            >Stornieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_book" max-width="400px">
      <v-card shaped>
        <v-card-title>
          <span class="headline"
            >Reservierung {{ locations[actual_location] }}</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="pa-0 px-0">
            <v-row>
              <v-col
                cols="12"
                class="text-center h5"
                v-if="!isMaxHoursExceeded"
              >
                {{ $moment(select.start).format("dddd DD MMMM YYYY") }}
                <br />
                <br />
                <!--<v-btn x-small depressed fab v-on:click="addStart(-1)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn x-small fab depressed v-on:click="addStart(1)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>-->
                {{ $moment(select.start).format("HH:mm") }} -
                {{ $moment(select.end).format("HH:mm") }}
                <!--<v-btn x-small depressed fab v-on:click="addEnd(-1)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn x-small fab depressed v-on:click="addEnd(1)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>-->
                <br />
                <br />
                {{
                  $moment(
                    $moment(select.end) - $moment(select.start) - 1
                  ).format("H")
                }}
                Stunde/n
                <br />
                <div v-if="mySelf">
                  <div v-if="mySelf.roles.includes('admin')">
                    <br />
                    <v-text-field
                      v-model="reservationText"
                      label="Reservierungstext"
                    ></v-text-field>
                  </div>
                </div>
                <div v-if="guest_system">
                  <br />

                  <v-btn x-small depressed fab v-on:click="addGuests(-1)">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                  {{ guests }} Gastspieler
                  <v-btn x-small fab depressed v-on:click="addGuests(1)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" class="text-center h5" v-else>
                Maximale Reservierungsdauer von
                <br />
                <br />
                {{ maxHours * 60 }} min
                <br />
                <br />
                überschritten
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red darken-1"
            text
            @click="
              dialog_book = false;
              close_dialog();
            "
            >Abbrechen</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isMaxHoursExceeded"
            color="blue darken-1"
            text
            @click="
              dialog_book = false;
              book();
            "
            >Reservieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_login" max-width="400px">
      <v-card shaped>
        <v-card-title>
          <span class="headline">{{ dialog_login_headline }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>{{ dialog_login_text }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialog_login = false"
            >Abbrechen</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!mySelf"
            color="blue darken-1"
            text
            @click="
              dialog_login = false;
              $router.push('login');
            "
            >Zur Anmeldung</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
const ics = require("ics");
import { downloadFile } from "../utils/files";
// import { deLocale } from "@fullcalendar/core/locales/de";
// import {
//   ref,
//   computed,
//   watch,
//   onBeforeMount,
//   onMounted,
// } from "@vue/composition-api";

export default {
  name: "Home",
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      snackbar_text: "",
      snackbar: false,
      event: {},
      select: {},
      select_selected: false,
      event_selected: false,
      dialog_event: false,
      dialog_book: false,
      dialog_login: false,
      dialog_login_headline: "",
      dialog_login_text: "",
      mytableheaders: [
        { text: "Adresse", value: "address" },
        { text: "PLZ", value: "plz" },
      ],
      mytable: [
        { address: "Copa", plz: "8401" },
        { address: "Ring", plz: "8010" },
      ],
      calendarEvents: [],
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        bootstrapPlugin,
      ],
      calendarHeader2: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      },
      calendarHeader: {
        left: "",
        center: "",
        right: "",
      },
      calendarView: "timeGridWeek",
      calendar: [],
      calendarDateStart: undefined,
      calendarDateEnd: undefined,
      locations: ["Platz 1", "Platz 2", "Platz 3", "Platz 4"],
      actual_location: 0,
      fullCalendarName: [
        "fullCalendar",
        "fullCalendar",
        "fullCalendar",
        "fullCalendar",
      ],
      last_event: undefined,
      minTime: { hours: 8 },
      maxTime: { hours: 22 },
      maxSelectHours: 2,
      guests: 0,
      isAdmin: false,
      isMaxHoursExceeded: false,
      maxHours: 2,
      guest_system: false,
      reservationText: "",
    };
  },
  mounted() {
    if (this.mySelf) {
      if (this.mySelf.roles.includes("admin")) {
        this.isAdmin = true;
        this.maxSelectHours = 12;
        // this.minTime = { hours: 7 };
      }
      this.reservationText = this.mySelf.nickname;
    }
    this.$moment.locale("de");
    this.calendarView = "timeGridWeek";
    this.calendar[0] = this.$refs.fullCalendar[0].getApi();
    this.calendar[1] = this.$refs.fullCalendar[1].getApi();
    this.calendar[2] = this.$refs.fullCalendar[2].getApi();
    this.calendar[3] = this.$refs.fullCalendar[3].getApi();
    /*this.$refs.fullCalendar[0].fullCalendar({
        dayRender: function(date, cell) {
          var today = this.fullCalendar.moment();
          var end = this.fullCalendar.moment().add(7, "days");

          if (date.get("date") == today.get("date")) {
            cell.css("background", "#e8e8e8");
          }
        }
    })*/
    this.calcCalendar();
    this.loadEvents();
    this.refresh(10000);
  },
  computed: {
    ...mapState({
      status: ({ user }) => user.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
      Events: ({ event }) => event.Events,
      CreatedEvent: ({ event }) => event.CreatedEvent,
      Event: (state) => state.event,
    }),
  },
  methods: {
    ...mapActions("auth", ["getMySelf", "logout"]),
    ...mapActions("event", [
      "getEvents",
      "deleteEvent",
      "updateEvent",
      "createEvent",
    ]),
    generateICS() {
      let start = this.$moment(this.event.start).format("YYYY, MM, DD, HH, mm");
      let end = this.$moment(this.event.end).format("YYYY, MM, DD, HH, mm");
      const event = {
        start: start.split(","), //[2021, 3, 1, 10, 30],
        end: end.split(","), //{ hours: 6, minutes: 30 },
        title: "Tennis",
        url: "https://atus.makerspace.at",
        busyStatus: "BUSY",
        calName: "My Calendar",
        method: "PUBLISH",
      };
      ics.createEvent(event, async (error, value) => {
        if (error) {
          console.log(error);
          return;
        } else {
          let blob = new Blob([value], {
            type: "text/plain;charset=utf-8",
          });
          const fileName = "event.ics";
          try {
            await downloadFile(blob, fileName, "text/plain;charset=utf-8");
          } catch (err) {
            console.log(err);
          }

          //let download_url = "webcal://" + value;
          //let x=new XMLHttpRequest();
          //x.open("GET", download_url, true);
          //x.setRequestHeader("Authorization", localStorage.getItem("Authorization") );
          //x.responseType = 'blob';
          //x.onload=function(e){
          // let file = new File([blob], fileName,{type: "text/plain"})
          // var objectURL = window.URL.createObjectURL(file);
          // window.open(objectURL);
          //}
          //x.send();
        }
      });
    },
    refresh(_intervall) {
      return setInterval(() => {
        //console.log("refresh");
        this.loadEvents();

        //this.$forceUpdate();
      }, _intervall);
    },
    test(event) {
      //console.log(event.event.extendedProps)
      //event.el.style = "background-color: white, content: 'red'"
      if (event.event.extendedProps.info) {
        let text = event.event.title;
        event.el.style =
          "--test: '" +
          text +
          "';background-color: rgb(221,221,221); font-size: 10px; color: black; opacity: 50%";
        //console.log(event.el.style)
      }
    },
    checkOverlap(event) {
      //console.log(event)
      //return true
      //const _event = _.find(this.Events, {'_id': event.id})
      //console.log(_event)
      if (event.extendedProps.info && (!event.extendedProps.info_blocked || this.mySelf.roles.includes('admin'))) {
        return true;
      } else {
        return false;
      }
    },
    calcCalendar() {
      this.calendarDateStart = this.$moment(this.calendar[0].getDate())
        .startOf("isoWeek")
        .format("DD MMM");
      this.calendarDateEnd = this.$moment(this.calendar[0].getDate())
        .endOf("isoWeek")
        .format("DD MMM YYYY");
    },
    eventClick(info, idx) {
      //console.log("eventClick", idx)
      //this.actual_location = idx;
      if (!this.mySelf) {
        this.dialog_login_headline = "Nicht angemeldet";
        this.dialog_login_text =
          "Sie müssen sich anmelden um Änderungen durchführen zu können.";
        this.dialog_login = true;
      } else if (
        this.$moment(info.event.start).format("X") <
          this.$moment().format("X") &&
        !this.isAdmin
      ) {
        this.dialog_login_headline = "Event nicht mehr änderbar";
        this.dialog_login_text =
          "Das Event liegt bereits in der Vergangenheit und kann daher nachträglich nicht mehr geändert werden.";
        this.dialog_login = true;
      } else {
        //if (this.mySelf.member) {
        this.recolorEvent();
        if (this.mySelf) {
          if (this.isAdmin || this.mySelf._id == info.event.groupId) {
            this.select_selected = false;
            this.event_selected = true;
            this.event = info.event;
            //this.dialog_event = true
            this.actual_location = idx;
            this.last_event = this.calendarEvents.find((el) => {
              return el.id == info.event.id;
            });
            this.last_event.backgroundColor = "blue";
          } else {
            //if(info.)

            /*const _event = _.find(this.Events, {'_id': info.event.id});
            console.log('EVENT CLICKED', _event);
            if (_event.info) {
              console.log(info.event.start)
              this.dateSelect(info, idx);
            } else {*/
            this.select_selected = false;
            this.event_selected = false;
            //}
          }
        }
      }
      /*else {
        this.dialog_headline = "Nicht Aktiv";
        this.dialog_login_text =
          "Sie wurden vom Administrator noch nicht freigeschaltet.";
        this.dialog_login_login = true;
        //this.$router.push("login");
      }*/
    },
    dateClick(info, idx) {},
    dateSelect(info, idx) {
      //console.log("dateSelect", idx)
      //this.actual_location = idx;
      this.recolorEvent();
      this.last_event = undefined;
      if (!this.mySelf) {
        this.dialog_login_headline = "Nicht angemeldet";
        this.dialog_login_text =
          "Sie müssen sich angemelden wenn Sie Änderungen durchführen möchten.";
        this.dialog_login = true;
      } else if (
        this.$moment(info.start).format("X") < this.$moment().format("X") &&
        !this.isAdmin
      ) {
        this.dialog_login_headline = "Datum liegt in der Vergangheit";
        this.dialog_login_text =
          "Das Datum liegt bereits in der Vergangenheit und kann daher nicht mehr reserviert werden.";
        this.dialog_login = true;
      } else {
        //if (this.mySelf.member) {

        this.select_selected = true;
        this.event_selected = false;
        this.select = info;
        this.actual_location = idx;

        let duration = (this.select.end - this.select.start) / 3600000;
        this.maxHours = this.maxSelectHours;
        //Platz 4 anders behandeln
        // if (this.actual_location == 3 && !this.mySelf.roles.includes('admin')) {
        //   this.maxHours = 1;
        // }
        //Platz 1&2 anders behandeln
        if (this.actual_location < 2 && !this.mySelf.roles.includes("admin")) {
          this.maxHours = 0;
          this.isMaxHoursExceeded = true;
          //this.snackbar_text = "Reservierungen für " + this.locations[this.actual_location] + " sind nicht erlaubt.";
          //this.snackbar = true;
        } else if (this.maxHours < duration) {
          this.isMaxHoursExceeded = true;
        } else {
          this.isMaxHoursExceeded = false;
        }

        this.dialog_book = true;
      }
      /*else {
        this.dialog_login_headline = "Nicht Aktiv";
        this.dialog_login_text =
          "Sie wurden vom Administrator noch nicht freigeschaltet.";
        this.dialog_login = true;
        //this.$router.push("login");
      }*/
    },
    addStart(h) {
      if (h <= -1) {
        let start = this.$moment(this.select.start)
          .subtract(1, "hour")
          .format();
        if (
          this.$moment(start).format("HH") <
          this.$moment(this.minTime).format("HH")
        ) {
          //
        } else {
          this.select.start = start;
        }
      } else if (h >= 1) {
        let start = this.$moment(this.select.start).add(1, "hour").format();
        if (
          start > this.$moment(this.select.end).subtract(1, "hour").format()
        ) {
          this.addEnd(+1);
        }
        if (
          this.$moment(start).format("HH") <
          this.$moment(this.maxTime).format("HH")
        ) {
          this.select.start = start;
        }
      }
    },
    addEnd(h) {
      if (h <= -1) {
        let end = this.$moment(this.select.end).subtract(1, "hour").format();
        if (end < this.$moment(this.select.start).add(1, "hour").format()) {
          this.addStart(-1);
        }
        if (
          this.$moment(end).format("HH") >
          this.$moment(this.minTime).format("HH")
        ) {
          this.select.end = end;
        }
      } else if (h >= 1) {
        let end = this.$moment(this.select.end).add(1, "hour").format();
        if (
          this.$moment(end).format("HH") >
          this.$moment(this.maxTime).format("HH")
        ) {
          //
        } else {
          this.select.end = end;
        }
      }
    },
    calendarNext() {
      if (
        this.$moment(this.calendar[0].getDate()).endOf("isoWeek").format("X") !=
          this.$moment().add(1, "week").endOf("isoWeek").format("X") ||
        this.isAdmin
      ) {
        this.calendar[0].next();
        this.calendar[1].next();
        this.calendar[2].next();
        this.calendar[3].next();
        this.calcCalendar();
        this.loadEvents();
      }
    },
    calendarPrev() {
      if (
        this.$moment(this.calendar[0].getDate())
          .startOf("isoWeek")
          .format("X") != this.$moment().startOf("isoWeek").format("X") ||
        this.isAdmin
      ) {
        this.calendar[0].prev();
        this.calendar[1].prev();
        this.calendar[2].prev();
        this.calendar[3].prev();
        this.calcCalendar();
        this.loadEvents();
      }
    },
    async book() {
      // Disable booking on Calendar 1 & 2
      if (this.actual_location > 1 || this.mySelf.roles.includes("admin")) {
        try {
          let _title = this.reservationText; //this.mySelf.nickname;
          if (this.guests > 0) {
            _title = _title + " +" + this.guests;
          }
          //console.log("book: ",this.actual_location)

          const event = {
            title: _title,
            user_id: this.mySelf._id,
            start: this.select.start,
            end: this.select.end,
            location: this.actual_location,
            guests: this.guests,
          };
          await this.createEvent(event);
          if (this.CreatedEvent && this.Event.statusCreate == "success") {
            /*let _id = this.CreatedEvent._id;
            this.calendarEvents.push({
              id: _id,
              groupId: this.mySelf._id,
              title: this.mySelf.displayname,
              start: this.select.start,
              end: this.select.end,
              backgroundColor: "#00CC22",
              textColor: "white",
              location: this.actual_location
            });*/

            this.loadEvents();
          } else {
            this.snackbar_text = "Reservierung fehlgeschlagen";
            this.snackbar = true;
            this.loadEvents();
          }
          this.guests = 0;
          this.select_selected = false;
        } catch (err) {
          this.snackbar_text = err;
          this.snackbar = true;
          this.loadEvents();
        }
        this.isMaxHoursExceeded = false;
      } else {
        this.snackbar_text =
          "Reservierungen für " +
          this.locations[this.actual_location] +
          " sind nicht erlaubt.";
        this.snackbar = true;
      }
    },
    close_dialog() {
      this.select_selected = false;
    },
    async cancel() {
      if (this.mySelf) {
        if (this.isAdmin || this.mySelf._id == this.event.groupId) {
          await this.deleteEvent(this.event.id);
          /*console.log(this.Event)
          if (this.Event.statusDelete == "success") {
            for (let idx in this.calendarEvents) {
              if (this.calendarEvents[idx].id == this.event.id) {
                this.calendarEvents.splice(idx, 1);
              }
            }
            this.event_selected = false
          }
          else {
            console.log("NOT CANCELED");
            this.loadEvents();
          }*/
          this.loadEvents();
        } else {
          //console.log("NOT ALLOWED");
        }
      }
    },
    async loadEvents() {
      const _start = this.$moment(this.calendar[0].getDate())
        .startOf("isoWeek")
        .format("X");
      const _end = this.$moment(this.calendar[0].getDate())
        .endOf("isoWeek")
        .format("X");
      //console.log(_start,_end)
      await this.getEvents({ start: _start, end: _end });

      let _events = JSON.parse(JSON.stringify(this.Events));

      for (let _event of _events) {
        _event.backgroundColor = "#AA0000";
        _event.textColor = "white";
        _event.id = _event._id;
        _event.groupId = _event.user_id;

        if (_event.info) {
          _event.backgroundColor = "#DDDDDD";
          _event.rendering = "background";
        }
      }
      let myEvents = _events.filter((e) => {
        try {
          return e.user_id == this.mySelf._id;
        } catch (e) {
          return e.user_id == "";
        }
      });
      for (let myEvent of myEvents) {
        if (this.last_event) {
          if (this.last_event.id == myEvent._id) {
            //console.log(this.last_event, myEvent)
            myEvent.backgroundColor = this.last_event.backgroundColor;
            this.last_event = myEvent;
            //this.last_event.backgroundColor = this.last_event.backgroundColor;
          } else {
            myEvent.backgroundColor = "#00CC22";
          }
        } else {
          myEvent.backgroundColor = "#00CC22";
        }
      }
      this.calendarEvents = _events;
    },
    async maxSelect(obj) {
      if (
        this.$moment(obj.end - obj.start).format("X") <=
        this.maxSelectHours * 60 * 60
      ) {
        return true;
      } else {
        return false;
      }
    },
    recolorEvent() {
      if (typeof this.last_event !== "undefined") {
        if (this.last_event.backgroundColor == "blue") {
          this.last_event.backgroundColor = "#00CC22";
        }
      }
    },
    addGuests(i) {
      this.guests = this.guests + i;
      if (this.guests < 0) {
        this.guests = 0;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  watch: {
    mySelf() {
      if (this.mySelf) {
        if (this.mySelf.roles.includes("admin")) {
          this.isAdmin = true;
          this.maxSelectHours = 12;
        }
      }
    },
  },
};
</script>

<style lang='scss'>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/bootstrap/main.css";

.card--flex-toolbar {
  margin-top: 0px;
  margin-bottom: 0px;
}
body {
  overflow-x: hidden;
}

.weekSelector {
  top: 56px;
  height: 66px;
  width: 100%;
  position: fixed;
  z-index: 2;
}
.calendarSection {
  top: 56px;
  height: 800px;
}

.fc-bgevent {
  &::before {
    content: var(--test);
  }
  //width: 90% !important;
}
.fc-axis.fc-time.fc-widget-content > span {
  &::after {
    content: "";
  }
  font-size: 11px;
  vertical-align: top;
  text-align: center;
}
</style>